<template>
  <b-row>
    <b-col class="mx-1 mt-2 mb-1" align-h="between">
      <div ref="cardContainer">
          <b-card border-variant="dark" class="fixed-height-card">
          <template #header>
            <div class="d-flex align-items-center">
              <b-icon icon="exclamation-triangle" class="mr-2 text-dark" font-scale="1.5"></b-icon>
              <span class="fs-1 font-weight-bold">Suspicious Process Chains</span>
            </div>
          </template>
          <b-list-group flush>
            <b-list-group-item
              v-for="(sentence, index) in anomalySentences"
              :key="index"
              class="px-3 py-2"
            >
              <template v-if="sentence.length > maxTextLength">
                <b-button v-b-toggle="'collapse-' + index" variant="link" class="p-0">
                  <ProcessSentenceTokens
                    :sentence="truncate(sentence)"
                    :actionableWords="actionableWords"
                  ></ProcessSentenceTokens>
                </b-button>
                <b-collapse :id="'collapse-' + index">
                  <b-card class="mt-2">
                    <ProcessSentenceTokens
                      :sentence="sentence"
                      :actionableWords="actionableWords"
                    ></ProcessSentenceTokens>
                  </b-card>
                </b-collapse>
              </template>
              <template v-else>
                <ProcessSentenceTokens
                  :sentence="sentence"
                  :actionableWords="actionableWords"
                ></ProcessSentenceTokens>
              </template>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import ProcessSentenceTokens from '@/xvisor/components/ProcessSentenceTokens.vue';

export default {
  props: {
    metadata: {
      type: Object,
      required: true,
    },
    alertType: {
      type: String,
      required: true,
    },
  },
  components: {
    ProcessSentenceTokens,
  },
  data() {
    return {
      maxTextLength: 0,
      actionableWords: ['executes', 'write'],
    };
  },
  computed: {
    anomalySentences() {
      return this.metadata.anomalySentences || [];
    },
  },
  methods: {
    truncate(text) {
      if (text.length > this.maxTextLength) {
        const substring = text.substring(0, this.maxTextLength);
        return `${substring}...`;
      }
      return text;
    },
    updateMaxTextLength() {
      this.$nextTick(() => {
        const cardE1 = this.$refs.cardContainer;
        if (!cardE1) return;
        const { width } = cardE1.getBoundingClientRect();
        this.maxTextLength = Math.floor(width - 1);
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.updateMaxTextLength();
      }, 0);
    });
    window.addEventListener('resize', this.updateMaxTextLength);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateMaxTextLength);
  },
};
</script>
